import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as yup from "yup";
import Header from "../Navbar/page";
import Sidenav from "../Navbar/sideNav/page";
import Api from '../Api/Api';
import copy from 'copy-to-clipboard';
import { RingLoader } from 'react-spinners';

function RefLink() {
    const [loginButtonLoader, setLoginButtonLoader] = useState(true);
     const [copySuccess, setCopySuccess] = useState("");
    const [userName, setUserName] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    const Auth = localStorage.getItem("Quizetoken");
     const getProfile = async () => {
               const token = localStorage.getItem("Quizetoken");
               if (!token) {
                 setLoading(false);
                 return; // Don't call API if user is not logged in
               }
               
               setLoading(true);
               try {
                 const res = await Api.get("user/get-profile");
                //  console.log("Profile", res.data.result);
                 setUserName(res.data.result?.userName);
               } catch (error) {
                 console.log("Error", error)
               }
               // }
               setLoading(false);
             };
     
             useEffect(()=> {
              getProfile();
             },[Auth]);

      const copyToClipboard = async() => {
        // console.log("coppy link")

        // const urlToCopy = copy(`https://membersnew.weshareabundance.com/login?u=${userName}`);
        const urlToCopy = copy(
          // `http://192.168.5.190:3000/sponsor-page/${userName}`
          `https://funmiracles.com/sponsor-page/${userName}`
        );
        try{
          document.cookie = `sponsorName=${userName}`
          if(urlToCopy){
            setCopySuccess("URL copied to clipboard!");
            // navigate(`/login?u=${userName}`, {
            //   state: { userName },
            // });
            // window.open(
            //   `http://44.195.125.80:10091/quiz-game/login?u=${userName}`,
            //   "_blank"
            // )
          }
          else{
            setCopySuccess("Failed to copy URL");
          }
        // console.log("copy",resp)

          // navigator.clipboard?.writeText(urlToCopy)
          //   .then(() => {
          //     console.log("copied","urlToCopy");
          //     // Clear the success message after 2 seconds
          //     setTimeout(() => setCopySuccess(""), 2000);
          //     navigate("/login",{
          //       state:{
          //         userName: {userName}
          //       }
          //     })
          //   })
         }
          catch(err ) {
            // console.error("Failed to copy: ", err);
            setCopySuccess("Failed to copy URL");
          };
      };
      // console.log("username", formikreg.values.name);

  return (
    <>
      {/* <ToastContainer /> */}
      {/* <Header /> */}
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <Sidenav />
        <div className="layout">
    <main className="content">
    <Header /> */}
      {loading ? (
        <div style={{ marginTop: "30%", marginLeft: "45%" }}>
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
          {/* <Header/> */}
          <section
            className="banner-section inner-banner position-relative about"
            style={{ height: "100%" }}
          >
            <div className="center">
              <div
                style={{ marginTop: "4%", marginLeft: "2%", cursor: "pointer" }}
              >
                <i class="fa fa-arrow-left" onClick={() => navigate("/")}></i>
              </div>
              <div className="video-form container">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-12">
                    <div className="log-img">
                      <img src="/assets/images/login.png" />
                    </div>
                    {/* )} */}
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <form
                      // onSubmit={formikreg.handleSubmit}
                      style={{ marginLeft: 0 }}
                    >
                      {/* <Link to="/">
                    <i
                      className="fa-solid fa-angle-left"
                      style={{ color: "black" }}
                    ></i>
                  </Link> */}
                      <div className="form-header">
                        <h2>Refer To Someone</h2>
                      </div>
                      <label for="email">
                        <b>Sponsor Name</b>
                      </label>
                      {/* <p>{`http://192.168.5.190:3000/sponsor-page/${userName}`}</p> */}
                      <p>{`https://funmiracles.com/sponsor-page/${userName}`}</p>

                      <button
                        type="button"
                        className="mt-5"
                        onClick={
                          () => copyToClipboard()
                          // window.open(
                          //   `https://membersnew.weshareabundance.com/register?u=${formikreg.values.name}`,
                          //   "_blank"
                          // )
                        }
                      >
                        <a>
                          {" "}
                          {loginButtonLoader ? "Copy the link" : "Please wait"}
                        </a>
                      </button>
                      <p>{copySuccess}</p>
                      {/* <a onClick={() => { 
                        setSingupContral(!singupContral); 
                        formik.resetForm(); // Reset login form
                        formikreg.resetForm(); // Reset registration form
                    }} className="signup-like">Already have an account? <span> Log In</span></a> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {/* </main>
        </div>
        
      </div> */}
    </>
  );
}

export default RefLink